import { reviews } from '@/mocks/baoyu';

export default function ReviewsSection() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <p className="text-sm text-primary-500 font-semibold tracking-wider mb-3">用户口碑</p>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950">他们的 baoyu 故事</h2>
          <p className="mt-4 text-foreground-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            来自不同领域用户的真实评价，见证 baoyu 带来的改变
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.slice(0, 3).map((review) => (
            <div
              key={review.id}
              className="bg-background-100 rounded-2xl p-6 md:p-7 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={review.avatar}
                  alt={review.name}
                  className="w-11 h-11 rounded-full object-cover"
                />
                <div>
                  <div className="text-sm font-semibold text-foreground-950">{review.name}</div>
                  <div className="text-xs text-foreground-600">{review.role}</div>
                </div>
              </div>
              <div className="flex items-center gap-0.5 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-xs ${i < review.rating ? 'ri-star-fill text-amber-400' : 'ri-star-line text-foreground-400'}`}
                  ></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed line-clamp-5">{review.content}</p>
              <p className="mt-4 text-xs text-foreground-500">{review.date}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <a href="/about#reviews" className="inline-flex items-center gap-2 text-sm text-primary-500 font-medium transition-colors duration-200 whitespace-nowrap hover:text-primary-600">
            查看更多评价
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}